import React from "react";
import { Drawer, Box } from "@mui/material";

const width = 280;

interface Props {
  children: React.ReactNode;
}

const Sidebar = ({ children }: Props) => {
  return (
    <Drawer
      variant="permanent"
      sx={{ width, flexShrink: 0, "& .MuiDrawer-paper": { width, boxSizing: "border-box" } }}
    >
      <Box height={64} />
      {children}
    </Drawer>
  );
};

export default Sidebar;
